import React from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { SubTitle } from 'ui-elements/main-elements/FsPaper/FsPaper.style-elements';
import { NotificationSettingsDataProps } from './NotificationSettings/NotificationSettings';

const { notifications: notificationsLocales } = defaultLocales.settingsPage;

export const tabs = [defaultLocales.notifications, defaultLocales.teammates];

export const notificationSettingsProps: NotificationSettingsDataProps = {
  title: notificationsLocales.title,
  subTitle: (
    <Box maxWidth={600}>
      <SubTitle>{notificationsLocales.subTitle}</SubTitle>
    </Box>
  ),
};
